import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { clientsAPI } from '../utils/api';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export const ClientTransactions = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTransactions();
  }, [id]);

  const loadTransactions = async () => {
    try {
      const response = await clientsAPI.getTransactions(id);
      setData(response.data);
    } catch (error) {
      // console.error('Error loading transactions:', error);
    } finally {
      setLoading(false);
    }
  };

  const exportPDF = async () => {
    const element = document.getElementById('transactions-content');
    const canvas = await html2canvas(element);
    const pdf = new jsPDF();
    const imgData = canvas.toDataURL('image/png');
    pdf.addImage(imgData, 'PNG', 10, 10, 190, 277);
    pdf.save(`${data.client.client_name}_transactions.pdf`);
  };

  if (loading) return <div className="container mt-4"><p>Loading...</p></div>;
  if (!data) return <div className="container mt-4"><p>No data found</p></div>;

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between mb-4">
        <h1>{data.client.client_name} - Transaction Details</h1>
        <button className="btn btn-primary" onClick={exportPDF}>Export as PDF</button>
      </div>

      <div id="transactions-content">
        <div className="row mb-4">
          <div className="col-md-4">
            <div className="card">
              <div className="card-body text-center">
                <h5 className="card-title">Total Purchases</h5>
                <h3>${data.summary.totalPurchases.toFixed(2)}</h3>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card">
              <div className="card-body text-center">
                <h5 className="card-title">Total Paid</h5>
                <h3>${data.summary.totalPaid.toFixed(2)}</h3>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card">
              <div className="card-body text-center">
                <h5 className="card-title">Outstanding Balance</h5>
                <h3 className="text-danger">${data.summary.balance.toFixed(2)}</h3>
              </div>
            </div>
          </div>
        </div>

        <div className="table-responsive">
          <table className="table table-striped">
            <thead className="table-light">
              <tr>
                <th>Date</th>
                <th>Product</th>
                <th>Quantity</th>
                <th>Price</th>
                <th>Total</th>
                <th>Amount Paid</th>
                <th>Balance</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {data.transactions.map((transaction) => (
                <tr key={transaction.id}>
                  <td>{new Date(transaction.transaction_date).toLocaleDateString()}</td>
                  <td>{transaction.product}</td>
                  <td>{transaction.quantity}</td>
                  <td>${transaction.price.toFixed(2)}</td>
                  <td>${(transaction.quantity * transaction.price).toFixed(2)}</td>
                  <td>${transaction.amount_paid.toFixed(2)}</td>
                  <td>${transaction.balance.toFixed(2)}</td>
                  <td>
                    <span className={`badge bg-${transaction.status === 'Completed' ? 'success' : 'warning'}`}>
                      {transaction.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
